<template>
  <transition name="slide" @after-leave="() => afterAnimation()">
    <v-app-bar fixed flat :color="statusBar.color" class="status" v-show="statusBar.show" ref="toolbar" height="64">
      <v-progress-circular indeterminate size="18" width="2" v-if="statusBar.progress" />
      <v-icon size="18" class="icon" :style="iconStyle" v-else>
        {{ statusBar.icon }}
      </v-icon>
      <div class="text__container">
        <div class="text" v-for="text of statusBar.text" :key="text">
          {{ $t(text) }}
        </div>
      </div>
      <v-spacer />
      <v-btn outlined @click="hideStatus()" v-if="statusBar.button">{{ $t("Ok") }}</v-btn>
    </v-app-bar>
  </transition>
</template>

<script>
import config from "@/config";
import { EVENT_NAMES } from "@teacherskaya/api-provider/dist";
import { $t } from "@/lib/helpers/i18nHelper";
import emitter from "@/lib/helpers/emitter";
import { EVENTS } from "@/lib/const";

export default {
  name: "StatusBar",
  data() {
    return {
      types: {
        success: {
          color: "#C9DCB5",
          icon: "done",
          iconStyle: {
            color: "#7BAA4B",
          },
        },
        pending: {
          color: "warning",
          icon: null,
          progress: true,
        },
        error: {
          color: "#E7C4C4",
          icon: "info",
          iconStyle: {
            color: "#DE857F",
          },
          button: true,
        },
      },
      statusBar: {
        show: false,
      },
      timeout: null,
      nextStatusBar: {},
    };
  },
  computed: {
    iconStyle() {
      const type = this.types[this.statusBar.type];
      if (!type || !type.iconStyle) return {};
      return type.iconStyle;
    },
  },
  methods: {
    addStatus(text, type = "success") {
      if (text === undefined) return;

      if (this.statusBar.type === "error") {
        if (type !== "error") return;
        if (!this.statusBar.text.find(item => item === text)) this.statusBar.text.push(text);
        return;
      }
      const status = {
        ...this.types[type],
        type,
        text: [text],
        show: true,
      };
      if (this.statusBar.show) {
        this.hideStatus();
        this.nextStatusBar = status;
      } else this.showStatus(status);
    },
    showStatus(status) {
      this.statusBar = status;
      clearTimeout(this.timeout);
      if (status.type !== "error") {
        this.timeout = setTimeout(this.hideStatus, config.notificationTimeout);
      }
    },
    hideStatus() {
      this.statusBar.show = false;
    },
    afterAnimation() {
      this.showStatus({ ...this.nextStatusBar });
      this.nextStatusBar = {};
    },
    parseError({ status, message, details }) {
      let text = message;
      if (
        details &&
        details.messageTemplate &&
        details.messageTemplate.substring(0, 1) === "{" &&
        details.messageTemplate.substring(details.messageTemplate.length - 1, details.messageTemplate.length) === "}"
      ) {
        text = $t(`$errors.${details.messageTemplate.replace(/[.]/g, "___")}`);
        if (text.startsWith("$errors.")) text = message;
      }
      this.addStatus(text, status);
    },
  },
  mounted() {
    emitter.on(EVENT_NAMES.REQUEST_STATUS, this.parseError);
    emitter.on(EVENTS.STATUS_NOTIFICATIONS.HIDE_ALL, this.hideStatus);
  },
  beforeDestroy() {
    emitter.off(EVENT_NAMES.REQUEST_STATUS, this.parseError);
    emitter.off(EVENTS.STATUS_NOTIFICATIONS.HIDE_ALL, this.hideStatus);
  },
};
</script>

<style scoped>
.text__container {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-items: flex-start;
  padding: 15px 0;
}
.text {
  margin-left: 10px;
  line-height: 1em;
  margin-bottom: 5px;
  color: #333333;
}
.text:last-child {
  margin-bottom: 0;
}

.status {
  z-index: 900;
}
.slide-enter-active {
  transition: 0.2s cubic-bezier(0, 0, 0.46, 0.07);
}

.slide-leave-active {
  transition: 0.1s cubic-bezier(0, 0, 0.46, 0.07);
}

.slide-enter-to,
.slide-leave {
  transform: translateY(0) !important;
  opacity: 1;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(-100%) !important;
  opacity: 0;
}
</style>
